import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

const BASE_URL = 'https://lal6c7zlrb.execute-api.us-east-1.amazonaws.com/prod/special';
@Injectable({
  providedIn: 'root'
})
export class ItemStatsService {

  constructor(public http: HttpClient) { }

  getItemStats() {
    const url = BASE_URL + '/itemstats';
    return this.http.get(url);
  }

  getUserStats() {
    const url = BASE_URL + '/userstats';
    return this.http.get(url);
  }
}
